import {PositionInterface} from '../../../shared/interfaces';
import {CheckboxControl} from '../../../shared/classes/controls';

export class PermissionGroupedSubControl {
    private formIndex: number;

    public id: string;
    public name: string;
    public control: CheckboxControl;
    public position: PositionInterface;
    public mainControlId: string;

    constructor(
        id: string,
        name: string,
        control: CheckboxControl,
        position: PositionInterface,
        mainControlId: string
    ) {
        this.id = id;
        this.name = name;
        this.control = control;
        this.position = position;
        this.mainControlId = mainControlId;

        this.formIndex = null;
    }

    setFormIndex(index: number): void {
        this.formIndex = index;
    }

    getFormIndex(): string {
        return this.formIndex.toString();
    }
}
